// Confirm.jsx
import React from 'react';

// Hooks
import { useIsMobile } from 'hooks/useDeviceDetect';

// CSS
import './Confirm.css';

// Components
import Button from 'components/button/Button';
import Modal from 'components/modal/Modal';
import ModalButtons from 'components/modal/buttons/ModalButtons';
import ModalMessage from 'components/modal/message/ModalMessage';

/**
 * Confirm
 * 
 * A simple confirmation modal component that can be used across the app for any action that requires user confirmation. It displays a title, a message, and a confirm button. The width of the modal adjusts for mobile screens.
 * 
 * @param {string} title - The title of the confirmation modal.
 * @param {string} message - The message to display in the modal body.
 * @param {boolean} isOpen - Whether the modal is currently open.
 * @param {function} setOpen - Function to set the open state of the modal.
 * @param {string} width - Optional width for the modal (defaults to 400px on desktop).
 * @param {function} onConfirm - Function to call when the confirm button is clicked.
 * 
 * @returns {JSX.Element} The rendered confirmation modal component.
 */
const Confirm = ({ title, message, isOpen, setOpen, width, onConfirm }) => {

  // ----- HOOKS ----- //

  const isMobile = useIsMobile();

  return (
    <>
      {/* MODAL */}
      <Modal title={title}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        height={"auto"}
        width={isMobile ? "100%" : width || "400px"}>

        {/* CONFIRM MESSAGE */}
        <ModalMessage text={message} />

        {/* BUTTONS */}
        <ModalButtons>

          {/* CONFIRM BUTTON */}
          <Button
            onClick={onConfirm}
            label="Confirm"
          />

        </ModalButtons>

      </Modal>
    </>
  );
};

export default Confirm;
